import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[noDecimal]'
})
export class NoDecimalDirective {

    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        if (event.key && event.key === '.') {
            event.preventDefault();
        }
    }
}
